import { io } from "socket.io-client";
import consts from "../constant";

export const socket = io(consts.socketUrl, {
    //  path: consts?.type === "production" ? "/socket" : "/socket.io",
    path: "/socket.io",
    transports: ["websocket", "polling"],
    withCredentials: false,
});